import { Color4 } from './Color4';
import { DimensionSource } from './DimensionSource';
import { DimensionSourceScale } from './DimensionSourceScale';
import { Direction } from './Direction';

export class GlowEffect {
  stroke: number;
  color: Color4;
  width: number;
  height: number;
}

export class ShadowEffect {
  offsetX: number;
  offsetY: number;
  color: Color4;
  opacity: number = 1.0;
}

export class ColorEffect {
  color: Color4;
}

export class TextRenderParameters {
  letterSpacing: number;
  isApplyKerning: boolean;
  isApplyAdvance: boolean; // for monofont
  advance: number; // for monofont
  glowEffect: GlowEffect | null;
  shadowEffect: ShadowEffect | null;
  colorEffect: ColorEffect | null;

  isClip: boolean = false;
  dimensionSource: DimensionSource = DimensionSource.Frame;
  dimensionSourceScale: DimensionSourceScale = DimensionSourceScale.Both;
  direction: Direction = Direction.LeftToRight;
  lang: Intl.LocalesArgument;
  constructor(
    letterSpacing: number = 0,
    isApplyKerning: boolean = false,
    isApplyAdvance: boolean = false,
    advance: number = 0
  ) {
    this.letterSpacing = letterSpacing;
    this.isApplyKerning = isApplyKerning;
    this.isApplyAdvance = isApplyAdvance;
    this.advance = advance;
  }
}
